<template>
  <div class="pay-success-back">
    {{ $t("payAdv.success") }}
  </div>
</template>

<script>
export default {
  name: "Success"
};
</script>

<style scoped>
.pay-success-back {
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: #1F3A43;
  color: white;
  display: flex;
  justify-content: center;
  padding-top: 150px;
  font-size: 58px;
}
</style>
